import React from "react";

import {
    Bell,
    Bike,
    IndianRupee,
    Star,
    AlertCircle,
    Trash2,
    CheckCircle2
} from "lucide-react";

import "./NotificationCard.css";

function NotificationCard({

    notification,

    onRead,

    onDelete

}) {

    const getNotificationMeta = () => {

        switch (notification.category) {

            case "delivery":

                return {

                    icon: <Bike size={22} />,

                    className: "delivery",

                    label: "Delivery"

                };

            case "payment":

                return {

                    icon: <IndianRupee size={22} />,

                    className: "payment",

                    label: "Payment"

                };

            case "review":

                return {

                    icon: <Star size={22} />,

                    className: "review",

                    label: "Review"

                };

            case "system":

                return {

                    icon: <AlertCircle size={22} />,

                    className: "system",

                    label: "System"

                };

            default:

                return {

                    icon: <Bell size={22} />,

                    className: "general",

                    label: "General"

                };

        }

    };

    const formatTime = (date) => {

        const now = new Date();

        const created = new Date(date);

        const diff = Math.floor((now - created) / 1000);

        if (diff < 60) return "Just now";

        if (diff < 3600)
            return `${Math.floor(diff / 60)} min ago`;

        if (diff < 86400)
            return `${Math.floor(diff / 3600)} hrs ago`;

        return created.toLocaleDateString();

    };

    const meta = getNotificationMeta();

    return (

        <div

            className={`hf-notification-card ${

                !notification.isRead ? "unread" : ""

            }`}

        >

            <div

                className={`hf-notification-icon ${meta.className}`}

            >

                {meta.icon}

            </div>

            <div className="hf-notification-content">

                <div className="hf-notification-header">

                    <h3>

                        {notification.title}

                    </h3>

                    {

                        !notification.isRead &&

                        <span className="hf-unread-dot"></span>

                    }

                </div>

                <div className="hf-notification-category">

                    {meta.label}

                </div>

                <p>

                    {notification.message}

                </p>

                <span className="hf-notification-time">

                    {formatTime(notification.createdAt)}

                </span>

            </div>

            <div className="hf-notification-actions">

                {

                    !notification.isRead && (

                        <button

                            className="hf-read-btn"

                            onClick={() => onRead(notification._id)}

                        >

                            <CheckCircle2 size={18} />

                        </button>

                    )

                }

                <button

                    className="hf-delete-btn"

                    onClick={() => onDelete(notification._id)}

                >

                    <Trash2 size={18} />

                </button>

            </div>

        </div>

    );

}

export default NotificationCard;